// extracted by mini-css-extract-plugin
export default {"Box":"table-cell-module__Box--EVWC0"};